import React from 'react'

import { connect } from "react-redux"

// need to use withRouter higher order component to access the routing history since the Lobbyist actions isn't a route
// we could pass in as props from parent but this makes it stand alone
import { withRouter } from 'react-router'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import ConfirmDialog from '../components/common/ConfirmDialog'
import ChangesRequiredDialog from '../components/lobbyist/changes-required-dialog'

import { STATUS_AWAITING_SUBMIT, STATUS_AWAITING_APPROVAL, STATUS_APPROVED, STATUS_REJECTED, STATUS_SURRENDERED, ROLE_ADMIN, ANNUAL_RETURN_TYPE_FINAL } from '../js/const'

import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as lobbyistActionCreators from "../actionCreators/lobbyist"
import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"

class LobbyistActions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowingChangesRequiredDialog: false
    }
  }

  goToLobbyists = () => {
    this.props.history.push('/')
  }

  // fourth step is for internal users to approve the lobbyist
  approve = lobbyistId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.approveLobbyist(lobbyistId)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  showChangesRequired = lobbyistId => {
    this.props.setLoading(true)
      .then(() => this.props.getChangesRequiredLobbyist(lobbyistId))
      .then(() => {
        this.setState({ isShowingChangesRequiredDialog: true })
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  closeChangesRequired = () => this.setState({ isShowingChangesRequiredDialog: false })

  // fourth step is for internal users can request changes
  changesRequiredFormSubmitted = lobbyist => {
    this.props.setLoading(true)
      .then(() => {
        this.props.changesRequiredLobbyist(lobbyist)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  // fourth step is for internal users can outright reject lobbyists
  reject = lobbyistId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.rejectLobbyist(lobbyistId)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  // lobbyist can apply for surrender
  requestSurrender = lobbyistId => {
    let annualReturnTypeLovId = this.props.lookupCode.annualReturnTypes.find(code => code.SystemCode === ANNUAL_RETURN_TYPE_FINAL).CodeLovId
    let currentYear = new Date().getFullYear()
    let startDate = new Date(currentYear, 0, 1, 0, 0, 0, 0)
    let endDate = new Date()
    let annualReturn = {
      LobbyistId: lobbyistId,
      TypeLovId: annualReturnTypeLovId,
      StartDate: startDate,
      EndDate: endDate
    }
    this.props.setLoading(true)
      .then(() => this.props.addAnnualReturn(annualReturn))
      .then(response => {
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          let annualReturnUrl = `/annual-return/${lobbyistId}/${response.data.SuccessOutput.AnnualReturnId}`
          this.props.history.push(annualReturnUrl)
          window.scrollTo(0, 0)
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  withdraw = lobbyistId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.withdrawLobbyist(lobbyistId)
          .then(response => {
            // set response in store so global response component can handle response
            this.props.setAjaxResponse(response)
            if (response.data.Success) {
              // lobbyist has successfully withdrawn so logout
              this.props.performLogout()
                .then(() => {
                  this.props.history.push('/')
                  this.props.setLoading(false)
                })
                .catch((error) => this.props.handleError(error)
                  .then(() => this.props.setLoading(false)))
            } else {
              this.props.setLoading(false)
            }
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  reactivate = lobbyistId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.reactivateLobbyist(lobbyistId)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  render() {
    // check if current lobbyist that is being looked at exists. If not create an empty object to deal with issues that could be caused by lobbyist being undefined
    let currentLobbyist = this.props.lobbyist.currentLobbyist ? this.props.lobbyist.currentLobbyist : {}
    let changesRequired = this.props.lobbyist.changesRequired ? this.props.lobbyist.changesRequired : {}

    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdd = !currentLobbyist.LobbyistId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let isAwaitingSubmission = currentLobbyist.StatusCode === STATUS_AWAITING_SUBMIT
    let isAwaitingApproval = currentLobbyist.StatusCode === STATUS_AWAITING_APPROVAL
    let isApproved = currentLobbyist.StatusCode === STATUS_APPROVED
    let isRejected = currentLobbyist.StatusCode === STATUS_REJECTED
    let isSurrendered = currentLobbyist.StatusCode === STATUS_SURRENDERED

    let isCorrectLobbyist = currentLobbyist.LobbyistId === this.props.auth.lobbyistId

    let canSave = (isAdd === false && isAuthenticated === true && (isAdmin === true || (isCorrectLobbyist && isAwaitingApproval === false))) || isAdd
    let canSubmit = isAdd === false && isAuthenticated === true && (isCorrectLobbyist || isAdmin === true) && isAwaitingSubmission
    let canApprove = isAdd === false && isAuthenticated === true && isAdmin === true && isAwaitingApproval
    let canRequestChanges = isAdd === false && isAuthenticated === true && isAdmin === true && isAwaitingApproval
    let canReject = isAdd === false && isAuthenticated === true && isAdmin === true
    let canRequestSurrender = isAdd === false && isAuthenticated === true && (isCorrectLobbyist || isAdmin === true) && isApproved
    let canWithdraw = isAdd === false && isAuthenticated === true && isAdmin === false && isCorrectLobbyist && (isAwaitingSubmission || isAwaitingApproval)
    let canReactivate = isAdd === false && isAdmin && (isRejected || isSurrendered)

      let saveLabel = isAdd ? "Create Profile" : "Save"
    return (
      <React.Fragment>
        <Toolbar>
          <div className="p-toolbar-group-left">
            {canSubmit && <Button label="Register" icon="pi pi-check" className="p-button-success"
              onClick={() => {
                this.props.setIsSubmitting(true)
                this.props.formApi.submitForm()
              }} />}
            {canApprove && <Button label="Approve" icon="pi pi-check" className="p-button-success" onClick={() => this.approve(currentLobbyist.LobbyistId)} />}
            {canRequestChanges && <Button label="Changes Required" icon="pi pi-exclamation-triangle"
              className="p-button-warning" onClick={() => this.showChangesRequired(currentLobbyist.LobbyistId)} />}
            {canSave && <Button label={saveLabel} icon="pi pi-check" className="p-button-primary"
              onClick={() => {
                this.props.setIsSubmitting(false)
                this.props.formApi.submitForm()
              }} />}
            {canReactivate && <Button label="Reactivate" icon="pi pi-check" className="p-button-success" onClick={() => this.reactivate(currentLobbyist.LobbyistId)} />}
            <Button label="Go to List of Lobbyists" className="p-button-secondary" onClick={this.goToLobbyists} />
          </div>
          <div className="p-toolbar-group-right">
                    {canReject && <ConfirmDialog buttonLabel="Refuse/ Cancel" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.reject(currentLobbyist.LobbyistId)}
                        title={'Confirm lobbyist rejection'} message={'Are you sure you wish to Refuse/ Cancel this lobbyist?'}
            />}
            {canWithdraw && <ConfirmDialog buttonLabel="Withdraw" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.withdraw(currentLobbyist.LobbyistId)}
              title={'Confirm lobbyist withdrawl'} message={'Are you sure you wish to withdraw this lobbyist ?'}
            />}
            {canRequestSurrender && <ConfirmDialog buttonLabel="Request Surrender" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.requestSurrender(currentLobbyist.LobbyistId)}
              title={'Confirm Surrender Request'} message={'Are you sure you wish to request a surrender? \n A final return must be submitted before a surrender can be processed. \n Please ensure you have entered the end dates for all employees and clients before surrendering'}
            />}
          </div>
        </Toolbar>
        {canRequestChanges && <ChangesRequiredDialog isShowingChangesRequiredDialog={this.state.isShowingChangesRequiredDialog} changesRequired={changesRequired}
          changesRequiredFormSubmitted={this.changesRequiredFormSubmitted} closeChangesRequired={this.closeChangesRequired} currentLobbyist={currentLobbyist}></ChangesRequiredDialog>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

// this is how to combine actions available
const actionCreators = {
  ...annualReturnActionCreators,
  ...lobbyistActionCreators,
  ...appActionCreators,
  ...authActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(LobbyistActions))


// WEBPACK FOOTER //
// ./src/container/LobbyistActions.js